// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__be5Ll","infoBtn":"quickbooks_infoBtn__3XqFV","formBox":"quickbooks_formBox__2Sg5H","formFooter":"quickbooks_formFooter__n4Vy2"};